import Auth from '../../../../auth';

const DATE = 'date';
const ODOMETER = 'odometer';
const RUNHOUR = 'runhour';
const MILES = 'miles';
const KILOMETERS = 'kilometers';
const MONTH = 'month';
const HOUR = 'hour';
const MAINTENANCE_ERROR_MESSAGE = 'An error occurred while creating the maintenance plan';
const MAINTENANCE_ALREADY_EXIST = 'The plan _ already exists. Please rename the Maintenance Plan.';

const EVENT_TRACKING_NAME = 'MaintenancePlanCreation';
const EVENT_TRACKING_ACTION = 'createButtonPressed';

const addToDataLayer = (data) => {
  window.dataLayer.push({
    event: EVENT_TRACKING_NAME,
    data: { ...data }
  });
}

export default function CreatePlanController(
  $scope,
  $rootScope,
  $state,
  MaintenanceService,
  gettextCatalog,
) {
  'ngInject';

  //Initial variables
  $scope.maxEmails = 10;
  $scope.selectedAssets = [];

  $scope.plan = {};
  $scope.emails = [];
  $scope.plan.tasks = [];
  $scope.plan.tags = [];
  $scope.plan.recurrence = {};
  $scope.plan.recurrence.algorithm = 'Offset';
  $scope.plan.recurrence.rules = [];
  $scope.plan.documentlinks = [];
  $scope.plan.recurrence.rules.push({
    type: DATE,
    frequency: MONTH,
    interval: 3,
    upcoming: 2,
  });
  $scope.$on('totalEmails', (event, totalEmails) => {
    $scope.maxEmails = totalEmails.length;
  });
  $scope.plan.recurrence.rules.push({
    type: RUNHOUR,
    frequency: HOUR,
    interval: 1000,
    upcoming: 50,
  }); //push at least one static rule

  $scope.plan.attrs = {};

  $scope.tags = [];

  $scope.$on('disableMeter', (event, args) => {
    $scope.meter_checked = args.Meter;
  });

  $scope.$on('disableDate', (event, args) => {
    $scope.date_checked = args.Calendar;
  });

  $scope.$on('meterRulesChange', (event, args) => {
    $scope.plan.recurrence.rules = $scope.plan.recurrence.rules.map(rule => {
      if (rule.type && (rule.type === ODOMETER || rule.type === RUNHOUR)) rule = args.MeterRules[0];
      return rule;
    });
  });

  $scope.$on('calendarRulesChange', (event, args) => {
    $scope.plan.recurrence.rules = $scope.plan.recurrence.rules.map(rule => {
      if (rule.type && rule.type === DATE) rule = args.CalendarRules[0];
      return rule;
    });
  });

  $scope.submitted = false;
  $scope.plan.contacts = [];
  $scope.meter_checked = false;
  $scope.notValid = false;

  $scope.saveButtonPressed = () => {
    $scope.userForm.$submitted = true;
    if (!$scope.equipmentChangeSet) return;

    addToDataLayer({
      action: EVENT_TRACKING_ACTION,
    });

    if (($scope.meter_checked || $scope.date_checked) && $scope.userForm.$valid) {
      $scope.notValid = false;

      $scope.plan.recurrence.rules = $scope.plan.recurrence.rules.filter(rule => {
        if (!$scope.meter_checked) return rule.type !== ODOMETER && rule.type !== RUNHOUR;

        if (!$scope.date_checked) return rule.type !== DATE;

        return true;
      });

      $scope.plan.recurrence.rules = $scope.plan.recurrence.rules.map(rule => {
        if (rule.frequency === MILES || rule.frequency === KILOMETERS) rule.type = ODOMETER;
        return rule;
      });

      $scope.plan.tags = $scope.plan.tags.map(tag => tag.text.toLowerCase());

      if ($scope.documentLinks && $scope.documentLinks.length >= 0) {
        $scope.plan.documentlinks = $scope.documentLinks;
      }

      const brand = Auth.getBrandClaim();
      if (brand != null) {
        $scope.plan.attrs.brand = brand;
      }

      if ($scope.plan.contacts.length <= $scope.maxEmails) {
        $scope.loading = true;
        MaintenanceService.createPlan($scope.plan, $scope.equipmentChangeSet)
          .then(response => {
            $rootScope.maintenancePlanData = response.data;
            $scope.plan.id = $rootScope.maintenancePlanData.id;
            return MaintenanceService.updateEquipmentForPlan(
              $scope.plan,
              $scope.equipmentChangeSet,
            );
          })
          .then(() => {
            $state.go('maintenance.plans-detail', {
              id: $scope.plan.id,
            });
          })
          .catch(error => {
            let errorMsg = gettextCatalog.getString(MAINTENANCE_ERROR_MESSAGE);
            if (error.status === 409) {
              const [frontMessage, tailMessage] = MAINTENANCE_ALREADY_EXIST.split('_');

              errorMsg =
                gettextCatalog.getString(frontMessage) +
                $scope.plan.name +
                gettextCatalog.getString(tailMessage);
            }
            if ((error.data || error.status) && error.status !== 409) {
              errorMsg = `${error.data || ''} ${error.statusText ||
                ''} : ${error.status.toString()}`;
            }
            $scope.errorFlag = true;
            $scope.errorText = errorMsg;
            $scope.loading = false;

            $scope.userForm.title.$setValidity('unique', false);
          });
      }
    } else {
      if (!($scope.meter_checked || $scope.date_checked)) {
        $scope.notValid = true;
      }
    }
  };

  $scope.formValidation = $scope.userForm;
}
